import React from "react";
import { Field } from "formik";
import { phoneMask } from "../../../utils/form/phoneMask";

import styles from "./PhoneInput.module.scss";

import { FieldPropsType, PhoneInputPropsType } from "./types";

export const PhoneInput: React.FC<PhoneInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, form, meta } = fieldProps;
        const hasValue = !!meta.value && meta.value.length > 0;
        const shouldShowLabelFocus = isFocused || hasValue;

        const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
          setIsFocused(true);
          
          // Если поле пустое, устанавливаем "+7" и курсор после "+7"
          if (!meta.value || meta.value.length === 0) {
            form.setFieldValue(name, "+7");
            setTimeout(() => {
              if (inputRef.current) {
                inputRef.current.setSelectionRange(2, 2);
              }
            }, 0);
          }
          
          if ('onFocus' in field && typeof field.onFocus === 'function') {
            field.onFocus(e);
          }
        };

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = phoneMask(e);
          if (newValue !== undefined) {
            form.setFieldValue(name, newValue);
            
            // Управление позицией курсора
            setTimeout(() => {
              if (inputRef.current) {
                const cursorPosition = inputRef.current.selectionStart || 0;
                const newCursorPosition = Math.max(2, cursorPosition); // Минимум позиция 2 (после "+7")
                
                // Если курсор находится перед "+7", перемещаем его после
                if (newValue && newValue.startsWith("+7") && cursorPosition < 2) {
                  inputRef.current.setSelectionRange(2, 2);
                } else {
                  inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
                }
              }
            }, 0);
          }
        };

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${shouldShowLabelFocus && styles.labelFocus}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type="tel"
              id={name}
              inputMode="numeric"
              placeholder={shouldShowLabelFocus ? placeholder : ""}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
                ${shouldShowLabelFocus ? styles.inputFocus : null}
              `}
              {...field}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={(e) => {
                setIsFocused(false);
                if ('onBlur' in field && typeof field.onBlur === 'function') {
                  field.onBlur(e);
                }
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};
